// User Data class
import { Email } from './Email';

export class UserData {
    claims;

    email;
    markets;
    market;
    categories;
    category;
    brands;
    brand;

    hasAccess;
    hasReadOnly;

    constructor(token) {
        this.claims = {};
        this.processToken(token);

        this.email = new Email(token?.email);
        this.markets = Object.keys(this.claims).sort();
        this.market = null;
        this.categories = null;
        this.category = null;
        this.brands = null;
        this.brand = null;
    }

    setMarket(market) {
        if (this.market && this.market === market) return false;
        this.market = this.markets.includes(market)
            ? market
            : this.markets[0] || null;
        this.categories = Object.keys(this.claims[this.market]);
        this.category = this.categories[0];
        this.brands = this.claims[this.market][this.category].map((b) => b.brand);
        this.brand = this.brands[0];

        this.hasReadOnly = this.hasReadOnlyAccess(this.market, this.category, this.brand)

        return true;
    }

    setCategory(category) {
        if (this.category && this.category === category) return false;
        this.category = this.categories.includes(category)
            ? category
            : this.categories[0] || null;

        this.brands = this.claims[this.market][this.category];
        this.brand = this.brands[0];

        this.hasReadOnly = this.hasReadOnlyAccess(this.market, this.category, this.brand)

        return true;
    }

    setBrand(brand) {
        if (this.brand && this.brand === brand) return false;
        this.brand = this.brands.includes(brand)
            ? brand
            : this.brands[0] || null;
        
        this.hasReadOnly = this.hasReadOnlyAccess(this.market, this.category, brand)

        return true;
    }

    // test process token
    processToken(token) {
        const tempPermissions = new Map();

        for (const key in token) {
            if (key.startsWith('APP:')) {
                const parts = key.split(':');
                const market = parts[1];
                const category = parts[2];
                const hasReadOnlyFlag = parts.length === 4;
                const brands = token[key].split(',').map((b) => b.trim());

                // Initialize nested structure
                if (!tempPermissions.has(market)) {
                    tempPermissions.set(market, new Map());
                }
                const marketMap = tempPermissions.get(market);

                if (!marketMap.has(category)) {
                    marketMap.set(category, new Map());
                }
                const categoryMap = marketMap.get(category);

                // Track permissions for each brand
                for (const brand of brands) {
                    if (!categoryMap.has(brand)) {
                        categoryMap.set(brand, {
                            readWrite: false,
                            readOnly: false,
                        });
                    }
                    const brandPerms = categoryMap.get(brand);

                    if (hasReadOnlyFlag) {
                        brandPerms.readOnly = true;
                    } else {
                        brandPerms.readWrite = true;
                    }
                }
            }
        }

        // Convert to final claims structure
        this.claims = {};

        for (const [market, categories] of tempPermissions.entries()) {
            this.claims[market] = {};

            for (const [category, brands] of categories.entries()) {
                this.claims[market][category] = [];

                for (const [brand, perms] of brands.entries()) {
                    // If brand has both readWrite and readOnly, readWrite takes precedence
                    const hasReadOnly = perms.readOnly && !perms.readWrite;

                    this.claims[market][category].push({
                        brand,
                        hasReadOnly,
                    });
                }
            }
        }

        this.hasAccess = Object.keys(this.claims).length !== 0;
    }

    // check if user has read-only access for a specific brand
    hasReadOnlyAccess(market, category, brand) {
        if (!this.claims[market] || !this.claims[market][category]) {
            return false;
        }

        const brandData = this.claims[market][category].find(
            (b) => b.brand === brand
        );
        return brandData ? brandData.hasReadOnly : false;
    }
}
